import { render, staticRenderFns } from "./LatestIdeas.vue?vue&type=template&id=57fdd831&scoped=true&"
import script from "./LatestIdeas.vue?vue&type=script&lang=js&"
export * from "./LatestIdeas.vue?vue&type=script&lang=js&"
import style0 from "./LatestIdeas.vue?vue&type=style&index=0&id=57fdd831&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fdd831",
  null
  
)

export default component.exports